import React, { useState, forwardRef, useImperativeHandle } from 'react'
import './uniagent.scss'
import { useRef } from 'react'
import createDebug from '@/common/create-debug'
import EE from '@/common/event'
import { useEffect } from 'react'
import { debounce } from 'lodash-es'
import { HelperCore } from '@/common/dependencies'

const debugOpenform = createDebug('openform')
const useStream = () => {
  const listeners = []
  let ended = false
  const emit = data => {
    if (ended) return
    if (data === 'ended') {
      ended = true
      listeners.forEach(listener => listener.finally && listener.finally())
      return
    }
    listeners.forEach(listener => listener.next && listener.next(data))
  }
  const stream = {
    pipe: callback => {
      listeners.push({next: callback})
    },
    finally: callback => {
      listeners.push({finally: callback})
    }
  }
  return [emit, stream]
}

const PromptFormParent = 'PROMPT-FORM-PARENT'
const PromptFormWrapperId = 'PROMPT-FORM-WRAPPER'
const AssistantChatInput = 'NM-ASSISTANT_chat_input' // 只有这个id需要添加到输入框上
/**
 * @param { items, submit, close, open } props 
 * @returns 
 */
const PromptFormList = (props, ref) => {
  const uniAgentRef = useRef(null)
  const closeForm = () => {
    uniAgentRef.current = null
    props.close && props.close()
    const parent = document.getElementById(PromptFormParent)
    if (parent) {
      parent.remove()
    }
  }

  EE.on('hide-agent-prompt-form', (e) => {
    const popup = document.getElementById(AssistantChatInput)
    const forms = document.getElementById('AgentForms')
    const folding = document.getElementById('AgentFormFolding')
    if (popup) {
      const isClickInside = (popup && popup.contains(e.target))
        || (forms && forms.contains(e.target))
        || (folding && folding.contains(e.target))
      if (!isClickInside) {
        closeForm()
      }
    }
  })
  const [emit, stream] = useStream()
  stream.pipe(data => {
    props.submit && props.submit(data)
  })
  stream.finally(() => {
    console.info('>>> 用户结束操作、关闭表单')
    closeForm()
    // props.close && props.close()
  })

  const openForm = (evt, item, ofc/** 外部覆盖样式 */) => {
    debugOpenform('openform')
    // evt 是一个 event 对象，拿到它在页面上的位置
    // const evtElement = evt.currentTarget
    // const {height, top} = evtElement.getBoundingClientRect()
    const {top, height} = document.getElementById(AssistantChatInput).getBoundingClientRect()
    // 在本 react 实例外创建一个新的容器，不然报错：同一个 react 容器不能执行两次 createRoot
    const divElement = document.createElement('div')
    divElement.id = PromptFormParent
    const { movetop = 0, minwidth = 0, maxwidth = 0, padding, } = ofc || {} // 用于兼容AI智能体页面
    const styles = {
      position: 'absolute',
      zIndex: '999',
      bottom: `${height}px`,
      left: `0`,
      width: `100%`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }
    Object.assign(divElement.style, styles)
    // document.body.appendChild(divElement)
    document.getElementById(AssistantChatInput).appendChild(divElement)
    // 创建一个子div用于居中表单
    const formWrap = document.createElement('div')
    formWrap.id = PromptFormWrapperId
    const wrapStyles = {
      width: '100%',
      maxWidth: (maxwidth || 800) + 'px',
      minWidth: (minwidth || 652) + 'px',
      padding: padding || '0 16px',
    }
    Object.assign(formWrap.style, wrapStyles)
    divElement.appendChild(formWrap)

    // 打开表单容器后，可能要等待容器渲染
    const isProd = import.meta.env.MODE === 'master'
    const mode = isProd ? '' : 'test'
    console.info('>>> 正在通过 UniAgent 创建表单', 'mode', mode)
    uniAgentRef.current = new UniAgent({
      containerId: PromptFormWrapperId,
      popupContainer: '#NM-ASSISTANT_chat_input',
      // mode: HelperCore.IS_PROD ? '' : 'test',
      mode,
      preview: true,
      previewData: item,
      // previewData,
      // formId: 'f5cecb0e-2d26-4c55-bde1-bb5a837f3758',
      formId: item.form_id,
    })
    uniAgentRef.current.render()
    debugOpenform('openform')
    // 执行以告知外部正在打开表单编辑
    props.open && props.open()
    /** string */
    setTimeout(() => {
      const payload = uniAgentRef.current.getFormPrompt()
      emit(payload)
    }, 1000)
    // console.info('>>> payload', payload)
    // if (!payload) {
    //   emit('none')
    // } else {
    //   emit(payload)
    // }
    // uniAgent.on('promptChange', payload => {
    //   console.info('promptChange', payload)
    //   payload.prompt && emit(payload.prompt)
    // })
    uniAgentRef.current.on('close', () => {
      emit('ended')
    })
  }

  useImperativeHandle(ref, () => ({
    getPrompt() {
      const payload =  uniAgentRef.current.getFormPrompt()
      console.info('>>> payload', payload)
      emit(payload)
      return payload
    },
    close() {
      closeForm()
    }
  }))

  // 表单列表长度超过视窗宽度时的交互
  const isChildExceedsParent = parentId => {
    // 获取父级元素
    const parentElement = document.getElementById(parentId);
    if (!parentElement) {
      // console.error('父级元素未找到');
      return -1;
    }
    // 获取父级元素的宽度
    const parentWidth = parentElement.offsetWidth;
    // 获取所有子元素
    const children = parentElement.children;
    // 初始化累加宽度
    let totalWidth = 0;
    // 遍历子元素
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      // 获取子元素的宽度（包括 margin-right）
      const childWidth = child.offsetWidth;
      const childMarginRight = parseFloat(window.getComputedStyle(child).marginRight) || 0;
      const childTotalWidth = childWidth + childMarginRight;
      // 累加宽度
      totalWidth += childTotalWidth;
      // 判断是否超过父级宽度
      if (totalWidth > parentWidth) {
        HelperCore.log(`超过父级宽度的子元素是第 ${i + 1} 个`);
        return i; // 返回第几个子元素（从 1 开始计数）
      }
    }
    // 如果没有子元素超过父级宽度
    HelperCore.log('没有子元素超过父级宽度');
    return -1;
  }

  const [folding, setFolding] = useState([])
  const [notFolding, setNotFolding] = useState(null)
  const [showFolding, setShowFolding] = useState(false)
  const mouseLeaveTimer = useRef(null)
  const [foldingLoading, setFoldingLoading] = useState(true)

  const shouldFolding = debounce(() => {
    setFoldingLoading(true)
    setNotFolding(props.items)
    setFolding([])
    setTimeout(() => {
      // setFoldingIndex(isChildExceedsParent('AgentForms'))
      const foldingIndex = isChildExceedsParent('AgentForms')
      if (foldingIndex > -1) {
        const notFolding = props.items.slice(0, foldingIndex - 1)
        const folding = props.items.slice(foldingIndex - 1)
        setFolding(folding)
        setNotFolding(notFolding)
      }
      setFoldingLoading(false)
    }, 120)
  }, 200)
  useEffect(() => {
    window.addEventListener('resize', () => {
      shouldFolding()
    })
    shouldFolding()
  }, [])

  const { classnames = [], overrideFormClassnames = {} } = props
  return (
    <div id="AgentForms" className={[
      'flex flex-row flex-nowrap justify-start items-center',
      'w-full max-w-800px min-w-652px whitespace-nowrap',
      'px-16px pb-14px',
      foldingLoading ? 'invisible' : 'visible',
      ...classnames
    ]}>
      {
        // 表单列表
        (notFolding || props.items).map((item, index) => {
          return (
            <div
              className={[
                'py-5px px-12px mr-6px rounded-8px border-1px border-solid border-[rgba(0,0,0,0.1)] bg-white',
                'cursor-pointer hover:bg-[#F0F2F5]'
              ]}
              key={item.name}
              onClick={evt => {
                openForm(evt, item, overrideFormClassnames)
              }}
            >
              <span className='text-14px color-black font-400 leading-24px'>{item.name}</span>
            </div>
          )
        })
      }
      {
        folding && folding.length > 0 && (
          <div
            // onClick={() => setShowFolding(!showFolding)}
            onMouseMove={() => {
              clearTimeout(mouseLeaveTimer.current)
              setShowFolding(true)
            }}
            onMouseLeave={() => {
              mouseLeaveTimer.current = setTimeout(() => {
                setShowFolding(false)
              }, 300)
            }}
            className="bg-white cursor-pointer hover:bg-[#F0F2F5] relative size-34px min-w-34px rounded-8px border-1px border-solid flex justify-center items-center"
          >
            {
              showFolding &&
              <div id="AgentFormFolding" className='bg-white absolute bottom-38px right-2px px-8px py-12px border-w-1px border-solid rounded-16px'>
                {
                  folding.map(item => {
                    return <p
                        key={item.name}
                        className='mb-0 px-8px py-9px text-14px leading-22px rounded-8px cursor-pointer color-[#000] hover:bg-[#F0F2F5]'
                        onClick={evt => {
                          evt.stopPropagation()
                          setShowFolding(false)
                          openForm(evt, item, overrideFormClassnames)
                        }}>
                          {item.name}
                        </p>
                  })
                }
              </div>
            }
            <img className="size-16px" src="https://p5.ssl.qhimg.com/d/inn/f9868e70c00a/more.png" alt="更多" />
          </div>
        )
      }
    </div>
  )
}

export default forwardRef(PromptFormList)
